/***********************************************
* Constants.js
* 
* Keep constant values for the application
***********************************************/

/* Production constants */
const prod = {
    API_URL: "https://" + window.location.hostname + "/api/",
    CAPTCHA_KEY: "6LeA3pUsAAAAAFN5wjQalG-vT_gWQQR5QNeS3QXu",
    TRACK_ID_APP: "G-YYVYVKYVB2",
    TRACK_ID_WEB: "G-JC0G03VV9N",
};

/* Development constants */
const dev = {
    //API_URL: "https://geopxl.com/api/",
    API_URL: "https://" + window.location.hostname + "/api/",
    CAPTCHA_KEY: "6LeA3pUsAAAAAFN5wjQalG-vT_gWQQR5QNeS3QXu",
    TRACK_ID_APP: "G-YYVYVKYVB2",
    TRACK_ID_WEB: "G-JC0G03VV9N",
};

/* Determine constants when building */
export const config = process.env.NODE_ENV === 'development' ? dev : prod;